module.exports = __webpack_public_path__ + "static/media/microwaveIcon.6adea449.svg";